import React, { useState, useRef, useEffect } from "react";
// import "../../CssFiles/appTest.css";
import { useNavigate } from "react-router-dom";


const AppTest = () => {
  const navigate = useNavigate(); 
  const [files, setFiles] = useState([]);
  const [showOptions, setShowOptions] = useState(false);
  const [showCamera, setShowCamera] = useState(false);
  const [capturedImage, setCapturedImage] = useState(null);
  const [randomText, setRandomText] = useState(
    "This text will change if cookie is present on helloTrade domain"
  );

  const fileInputRef = useRef(null);

  const handleFileUpload = (event) => {
    const uploadedFiles = Array.from(event.target.files);
    setFiles((prevFiles) => [...prevFiles, ...uploadedFiles]);
  };

  const handlePhotoOption = (option) => {
    if (option === "gallery") {
      document.getElementById("fileInput").click();
    } else if (option === "camera") {
      setShowCamera(true);
    }
    setShowOptions(false);
  };

  const handlePhotoCapture = async () => {
    try {
      const stream = await navigator.mediaDevices.getUserMedia({
        video: true,
        audio: false,
      });
      const track = stream.getVideoTracks()[0];
      const imageCapture = new ImageCapture(track);
      const blob = await imageCapture.takePhoto();
      setCapturedImage(URL.createObjectURL(blob));
      track.stop();
    } catch (error) {
      console.error("Error capturing photo: ", error);
    }
  };

  const handleUploadCapturedPhoto = () => {
    if (capturedImage) {
      fetch(capturedImage)
        .then((res) => res.blob())
        .then((blob) => setFiles((prevFiles) => [...prevFiles, blob])); // Corrected update
      setCapturedImage(null);
      setShowCamera(false);
    }
  };

  const handleDownload = (file) => {
    const url = URL.createObjectURL(file);
    const link = document.createElement("a");
    link.href = url;
    link.download = file.name || "captured_image.jpg";
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };

  const triggerFileInput = () => {
    fileInputRef.current.click();
  };

  const checkCookies = () => {
    const allCookies = document.cookie.split("; ");
    if (allCookies.length > 0) {
      let cookiesList = allCookies
        .map((cookie, index) => `cookie${index + 1}: ${cookie.split("=")[0]}`)
        .join(", ");
      setRandomText(cookiesList);
    }
  };

  // Function to inject the Upload Document button
  function injectUploadDocumentButton() {
    let docButton = document.createElement("button");
    docButton.innerText = "Upload Document";
    styleButton(docButton);
    docButton.style.top = "40%"; // Position it

    let docInput = document.createElement("input");
    docInput.type = "file";
    docInput.accept = "image/x-png,image/jpeg,application/pdf";
    docInput.style.display = "none";
    docInput.multiple = true; 
    document.body.appendChild(docInput);

    docButton.onclick = function () {
      docInput.click();
    };

    docInput.onchange = function (event) {
        let files = event.target.files;
        if (files.length > 0) {
          console.log("Uploaded Documents/Files:");
          Array.from(files).forEach(file => console.log(file.name));
        }
    };

    document.body.appendChild(docButton);
  }

  // Function to inject the Upload Photograph button
  function injectUploadPhotographButton() {
    let photoButton = document.createElement("button");
    photoButton.innerText = "Upload Photograph";
    styleButton(photoButton);
    photoButton.style.top = "50%"; // Position below the document button

    let photoInput = document.createElement("input");
    photoInput.type = "file";
    photoInput.accept = "camera/*";
    photoInput.style.display = "none";

    document.body.appendChild(photoInput);

    photoButton.onclick = function () {
      photoInput.click();
    };

    photoInput.onchange = function (event) {
      let file = event.target.files[0];
      if (file) {
        readImageFile(file);
      }
    };

    document.body.appendChild(photoButton);
  }

  // Function to apply common styling to buttons
  function styleButton(button) {
    button.style.position = "fixed";
    button.style.left = "50%";
    button.style.transform = "translateX(-50%)";
    button.style.zIndex = "1000";
    button.style.padding = "10px 20px";
    button.style.backgroundColor = "#007BFF";
    button.style.color = "white";
    button.style.border = "none";
    button.style.borderRadius = "5px";
    button.style.cursor = "pointer";
    button.style.fontSize = "16px";
  }

  // Function to read the selected image as Base64
  function readImageFile(file) {
    let reader = new FileReader();
    reader.onload = function (event) {
      let base64String = event.target.result;
      console.log("Base64 Image:", base64String);
    };
    reader.readAsDataURL(file);
  }

  function injectDownloadButton() {
    let button = document.createElement("button");
    button.innerText = "Download Sample PDF";
    button.style.position = "fixed";
    button.style.left = "50%";
    button.style.transform = "translateX(-50%)";
    button.style.zIndex = "1000";
    button.style.padding = "10px 20px";
    button.style.backgroundColor = "#007BFF";
    button.style.color = "white";
    button.style.border = "none";
    button.style.borderRadius = "5px";
    button.style.cursor = "pointer";
    button.style.fontSize = "16px";
    button.style.top = "60%";

    button.onclick = function () {
      let link = document.createElement("a");
      link.href =
        "https://www.w3.org/WAI/ER/tests/xhtml/testfiles/resources/pdf/dummy.pdf"; // Sample PDF URL
      link.download = "Sample.pdf";
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    };

    document.body.appendChild(button);
  }

  useEffect(() => {
    checkCookies();
    injectUploadDocumentButton();
    injectUploadPhotographButton();
    injectDownloadButton();
  }, []);

    return (
  //     <div className="app-container">
  //       <header className="header">
  //         <h1 className="header-title">Test Page</h1>
  //       </header>

  //       <div className="container">
      <>
        <p className="description">{randomText}</p>
        <div
          style={{
            width: "200px",
            height: "100px",
            backgroundColor: "#4CAF50", // Nice green background
            color: "#fff", // White text for contrast
          }}
          onClick={() => navigate("/")} // Add your onClick logic here
        >
          Go to Home
        </div>
      </>
         
  //         <h2 className="heading" onClick={triggerFileInput}>
  //           Upload & Capture Files
  //         </h2>

  //         <input
  //           type="file"
  //           ref={fileInputRef}
  //           id="fileInput"
  //           multiple
  //           accept=".jpg,.jpeg,.png,.pdf"
  //           onChange={handleFileUpload}
  //           className="hidden"
  //         />

  //         <button
  //           className="btn primary-btn"
  //           onClick={() => setShowOptions(true)}
  //         >
  //           Upload Photograph
  //         </button>

  //         {showOptions && (
  //           <div className="modal">
  //             <button
  //               className="modal-btn"
  //               onClick={() => handlePhotoOption("gallery")}
  //             >
  //               📂 Select from Gallery
  //             </button>
  //             <button
  //               className="modal-btn"
  //               onClick={() => handlePhotoOption("camera")}
  //             >
  //               📸 Use Camera
  //             </button>
  //           </div>
  //         )}

  //         {showCamera && (
  //           <div className="camera-section">
  //             <video autoPlay className="video-preview"></video>
  //             <button className="btn secondary-btn" onClick={handlePhotoCapture}>
  //               Capture Photo
  //             </button>
  //             {capturedImage && (
  //               <>
  //                 <img
  //                   src={capturedImage}
  //                   alt="Captured"
  //                   className="preview-image"
  //                   style={{ width: "100%" }}
  //                 />
  //                 <button
  //                   className="btn primary-btn"
  //                   onClick={handleUploadCapturedPhoto}
  //                 >
  //                   Upload
  //                 </button>
  //               </>
  //             )}
  //           </div>
  //         )}

  //         <h3 className="sub-heading">Uploaded Files</h3>
  //         <ul className="file-list">
  //           {files.map((file, index) => (
  //             <li key={index} className="file-item">
  //               {file.name || "Captured Image"}
  //               <button
  //                 className="download-btn"
  //                 onClick={() => handleDownload(file)}
  //               >
  //                 ⬇ Download
  //               </button>
  //             </li>
  //           ))}
  //         </ul>
  //       </div>
  //     </div>
    );
};

export default AppTest;
